module.exports = __webpack_public_path__ + "static/media/fiat-go-drive.07ea962f.jpg";